// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICommercialVehiclePermitType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
    maxVehicleWeight: number;
    maxVehicleHeight: number;
    maxVehicleWidth: number;
    maxVehicleLength: number;
}

export class CommercialVehiclePermitType implements ICommercialVehiclePermitType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;
    public maxVehicleWeight: number;
    public maxVehicleHeight: number;
    public maxVehicleWidth: number;
    public maxVehicleLength: number;

    /**
		Returns Over Size/Weight CommercialVehiclePermitType
	**/
    get OverSizeWeight(): ICommercialVehiclePermitType {
        return this.FromId(1);
    }
    /**
		Returns International POE CommercialVehiclePermitType
	**/
    get InternationalSingleTrip(): ICommercialVehiclePermitType {
        return this.FromId(2);
    }

    get EnvelopeOverSize(): ICommercialVehiclePermitType {
        return this.FromId(3);
    }

    get EnvelopeOverSizeWeight(): ICommercialVehiclePermitType {
        return this.FromId(4);
    }

    get Houseboat(): ICommercialVehiclePermitType {
        return this.FromId(5);
    }

    get SingleTrip(): ICommercialVehiclePermitType {
        return this.FromId(6);
    }

    get Registration(): ICommercialVehiclePermitType {
        return this.FromId(7);
    }

    get UseFuel(): ICommercialVehiclePermitType {
        return this.FromId(8);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'OverSizeWeight', displayValue: 'Over Size/Weight', description: 'Over Size/Weight', sortOrder: 1, active: true, maxVehicleWeight: 80000, maxVehicleHeight: 192, maxVehicleWidth: 168, maxVehicleLength: 1440 });
        this._dictionary.add('2', { id: 2, value: 'InternationalSingleTrip', displayValue: 'International Single Trip', description: 'International Single Trip', sortOrder: 1, active: true, maxVehicleWeight: 0, maxVehicleHeight: 0, maxVehicleWidth: 0, maxVehicleLength: 0 });
        this._dictionary.add('3', { id: 3, value: 'EnvelopeOverSize', displayValue: 'Envelope Over Size', description: 'Envelope Over Size', sortOrder: 1, active: true, maxVehicleWeight: 0, maxVehicleHeight: 0, maxVehicleWidth: 0, maxVehicleLength: 0 });
        this._dictionary.add('4', { id: 4, value: 'EnvelopeOverSizeWeight', displayValue: 'Envelope Over Size/Weight', description: 'Envelope Over Size/Weight', sortOrder: 1, active: true, maxVehicleWeight: 0, maxVehicleHeight: 0, maxVehicleWidth: 0, maxVehicleLength: 0 });
        this._dictionary.add('5', { id: 5, value: 'Houseboat', displayValue: 'Houseboat (limited area of travel)', description: 'Houseboat (limited area of travel)', sortOrder: 1, active: true, maxVehicleWeight: 15000, maxVehicleHeight: 300, maxVehicleWidth: 197, maxVehicleLength: 1440 });
        this._dictionary.add('6', { id: 6, value: 'SingleTrip', displayValue: 'Single Trip', description: 'Single Trip', sortOrder: 1, active: true, maxVehicleWeight: 0, maxVehicleHeight: 0, maxVehicleWidth: 0, maxVehicleLength: 0 });
        this._dictionary.add('7', { id: 7, value: 'Registration', displayValue: 'Registration', description: 'Registration', sortOrder: 1, active: true, maxVehicleWeight: 0, maxVehicleHeight: 0, maxVehicleWidth: 0, maxVehicleLength: 0 });
        this._dictionary.add('8', { id: 8, value: 'UseFuel', displayValue: 'Use Fuel', description: 'Use Fuel', sortOrder: 1, active: true, maxVehicleWeight: 0, maxVehicleHeight: 0, maxVehicleWidth: 0, maxVehicleLength: 0 });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICommercialVehiclePermitType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICommercialVehiclePermitType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICommercialVehiclePermitType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICommercialVehiclePermitType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICommercialVehiclePermitType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
